/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { SearchBox } from 'react-instantsearch';
import PropTypes from 'prop-types';
import { connectStateResults } from 'commons/react-instantsearch-dom-wrappers';

import publicImgBaseURL from 'commons/publicImgBaseURL';
import JBImage from 'components/essentials/JBImage';
import IconSearch from 'components/icons/IconSearch';
import VisuallyHidden from 'components/consumer/VisuallyHidden';

/*
 *  Mobile Search Dropdown List
 */
export const ReviewSearchOptions = connectStateResults(
  ({ searchResults, ...otherProps }) => {
    if (!searchResults) {
      return null;
    }
    if (
      !otherProps.inSearchMode &&
      otherProps.onProduct !== null &&
      !searchResults.query.length
    ) {
      otherProps.onSearchUpdate(false);
    }

    if (searchResults.query.length < 2) {
      return null;
    }

    if (
      !otherProps.inSearchMode &&
      searchResults.hits.length &&
      !otherProps.onProduct
    ) {
      otherProps.onSearchUpdate(true);
    } else if (!otherProps.inSearchMode && otherProps.onProduct !== null) {
      return null;
    }
    return (
      <>
        {!!searchResults.query.length > 0 && !!searchResults.hits.length && (
          <VisuallyHidden>
            {searchResults.hits.length} products found
          </VisuallyHidden>
        )}

        <ul className="top-[42px] left-0 w-full px-2 py-6 bg-white z-[1889] list-none m-0">
          {searchResults.query.length > 0 && searchResults.hits.length
            ? searchResults.hits.map(review => (
                <li
                  className="items-center flex flex-row justify-start list-none m-0 p-0 w-full"
                  key={review?.fk_product_id}
                >
                  <button
                    className="[background:none] border-0 w-full flex flex-row items-center justify-start px-0 py-4 cursor-pointer focus-visible:bg-gray-light8 hover:bg-gray-light8"
                    onClick={() =>
                      otherProps.onProductClicked(
                        review.fk_product_id,
                        review.product_name
                      )
                    }
                    type="button"
                  >
                    <div className="pl-4 w-2/5">
                      <JBImage
                        src={publicImgBaseURL(review.image_link)}
                        width={200}
                        alt={review?.product_name || ''}
                      />
                    </div>

                    <div className="pr-4 text-[.8rem] text-[#585858] font-normal ml-6">
                      {review.product_name}
                    </div>
                  </button>
                </li>
              ))
            : null}
        </ul>
      </>
    );
  }
);

export const ReviewSearchBox = ({ defaultRefinement }) => (
  <div className="[&_i]:w-[18px] [&_i]:h-[18px] [&_i]:text-[18px] [&_i]:block [&_i]:absolute [&_i]:top-1/2 [&_i]:mt-[-9px] [&_i]:right-10 [&_i]:cursor-pointer [&_i]:[border-right:1px_solid_#dfe0e1] bg-gray-light8 py-[.2rem] min-h-[52px] border border-solid border-gray-light3 bg-transparent text-gray-light1 [&_.ais-SearchBox]:w-[inherit] [&_.ais-SearchBox-form]:flex [&_.ais-SearchBox-form_.ais-SearchBox-input]:text-[.8rem] [&_.ais-SearchBox-form_.ais-SearchBox-input]:h-11 [&_.ais-SearchBox-form_.ais-SearchBox-input]:w-full [&_.ais-SearchBox-form_.ais-SearchBox-input]:text-gray-dark [&_.ais-SearchBox-form_.ais-SearchBox-input]:block [&_.ais-SearchBox-form_.ais-SearchBox-input]:border [&_.ais-SearchBox-form_.ais-SearchBox-input]:border-solid [&_.ais-SearchBox-form_.ais-SearchBox-input]:border-transparent [&_.ais-SearchBox-form_.ais-SearchBox-input]:pt-0 [&_.ais-SearchBox-form_.ais-SearchBox-input]:pr-0 [&_.ais-SearchBox-form_.ais-SearchBox-input]:pb-0 [&_.ais-SearchBox-form_.ais-SearchBox-input]:!pl-[2.2rem] [&_.ais-SearchBox-form_.ais-SearchBox-input]:leading-[32px] [&_ .ais-SearchBox-form_.ais-SearchBox-input::placeholder]:text-left [&_.ais-SearchBox-reset]:[background:inherit] [&_.ais-SearchBox-reset]:border-0 [&_.ais-SearchBox-reset]:cursor-pointer [&_.ais-SearchBox-reset]:!flex [&_.ais-SearchBox-reset]:items-center [&_.ais-SearchBox-submit]:hidden">
    <div className="flex flex-row items-stretch relative box-border min-[1440px]:mx-[1.333vw] min-[1440px]:my-0 px-2 py-0 m-0 [&_input]:pt-0 [&_input]:pr-0 [&_input]:pb-0 [&_input]:pl-[15px] [&_.ais-SearchBox-reset]:hidden">
      <IconSearch className="self-center min-w-[16px]" width={18} height={18} />

      <label className="inline-flex w-full [&_.ais-SearchBox-input::-webkit-search-cancel-button]:appearance-none">
        <VisuallyHidden>
          Search - Start typing, then use the up and down arrows to select an
          option from the list
        </VisuallyHidden>

        <SearchBox
          translations={{}}
          /* TODO: CON-7887: (Codemod generated): Move this into `InstantSearch`'s `initialUiState` prop.
          See https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/react/#default-refinements */
          defaultRefinement={defaultRefinement}
          placeholder="Search"
        />
      </label>
    </div>
  </div>
);

ReviewSearchBox.propTypes = {
  defaultRefinement: PropTypes.string,
};

export const sortOptions = [
  { value: 'date-desc', label: 'Recent' },
  { value: 'date-asc', label: 'Oldest' },
  { value: 'rating-desc', label: 'High Rated' },
  { value: 'rating-asc', label: 'Low Rated' },
];
